const shape = {
  borderRadius: 0,
}

export default shape
